class QuickCourseSearch extends HTMLElement {
  constructor() {
    super();

    this.openModalButton = this.querySelector("[quick-search-open]");
    this.closeButton = this.querySelector(".close-button");
    this.siteDrawer = document.querySelector(".site-drawer");
    this.closeModalButton = this.querySelector("[quick-search-close]");
    this.form = this.querySelector("form");
    this.submitButton = this.querySelector(".js-check-availability-button");
    this.locationAutocompleteBox = this.querySelector(".location-autocomplete");
    this.autocompleteLoations =
      this.locationAutocompleteBox?.querySelectorAll("button");
    this.courseTypesJSON = JSON.parse(
      this.querySelector("[quick-search-course-type-json]")?.textContent
    );
    this.selectors = {
      location: {
        param: "filter.v.m.wpt.location",
        element: this.querySelector("input[name='filter.v.m.wpt.location']"),
      },
      fromDate: {
        param: "from-date",
        element: this.querySelector("input[name='from-date']"),
      },
      toDate: {
        param: "to-date",
        element: this.querySelector("input[name='to-date']"),
      },
      courseType: {
        param: "course-type",
        element: this.querySelector("select[name='course-type']"),
      },
    };

    this.autocompleteLoations.forEach((button) => {
      button.addEventListener("click", (event) => {
        this.onAutocompleteClick(event);
      });
    });

    this.selectors.location.element.addEventListener("input", (event) => {
      this.locationOnChange(event);
    });

    this.form.addEventListener("submit", (event) => {
      event.preventDefault();
      this.onSubmit(event);
    });

    this.openModalButton.addEventListener("click", (event) => {
      this.onChange(event);
    });

    this.closeButton.addEventListener("click", (event) => {
      this.onClose(event);
    });

    this.init();
  }
  onAutocompleteClick(event) {
    const selectedLocation = event.target.textContent.trim().toLowerCase();
    this.selectors.location.element.value = selectedLocation;
    this.locationAutocompleteBox.classList.add("hidden");
    this.autocompleteLoations.forEach((button) => {
      button.classList.add("hidden");
    });
  }

  locationOnChange(event) {
    const selectedLocation = event.target.value.toLowerCase().trim();
    if (!selectedLocation) {
      this.locationAutocompleteBox.classList.add("hidden");
    } else {
      this.locationAutocompleteBox.classList.remove("hidden");
    }
    this.autocompleteLoations.forEach((button) => {
      const lowercaseText = button.textContent.trim().toLowerCase();
      if (lowercaseText.includes(selectedLocation)) {
        button.classList.remove("hidden");
      } else {
        button.classList.add("hidden");
      }
    });
  }

  init() {
    const urlParams = new URLSearchParams(window.location.search);
    Object.values(this.selectors).forEach(({ param, element }) => {
      if (urlParams.has(param) && element) {
        element.value = urlParams.get(param);
      }
    });
    // Initialize the date pickers
    const niceSelect = this.querySelector("#course-type");
    if (
      niceSelect &&
      window.Moonbase &&
      typeof window.Moonbase.NiceSelect === "function"
    ) {
      const instance = new window.Moonbase.NiceSelect(niceSelect, {
        searchable: false,
      });
      instance.update();
    }
  }

  onSubmit() {
    const collectionContainer = document.querySelector(
      ".collection-content__container"
    );
    if (collectionContainer) {
      collectionContainer.classList.add("loading");
    }
    const formData = new FormData(this.form);
    let params = new URLSearchParams();
    for (const [key, value] of formData.entries()) {
      params.append(key, value);
    }
    let selectedItem = null;
    if (window.innerWidth > 1024) {
      const dropdownItems = this.querySelectorAll(
        ".nice-select-dropdown ul li"
      );
      selectedItem = Array.from(dropdownItems).find((item) =>
        item.classList.contains("selected")
      );
    } else {
      // find .form-select element and get the selected item
      const selectElement = this.querySelector("select[name='course-type']");
      selectedItem = selectElement
        ? selectElement.options[selectElement.selectedIndex]
        : null;
    }

    if (selectedItem) {
      const selectedItemTitle = selectedItem.textContent
        .trim()
        .replace(/\s+/g, "_")
        .toLowerCase();
      const courseTypeKey = Object.keys(this.courseTypesJSON).find(
        (key) => key === selectedItemTitle
      );
      if (courseTypeKey) {
        window.location.href = `${window.origin}${this.courseTypesJSON[courseTypeKey]}`;
        return;
      }
    } else {
      console.log("No course type selected");
      return;
    }

    // Capitalize the value for filter.v.m.wpt.location param
    if (params.has("filter.v.m.wpt.location")) {
      const loc = params.get("filter.v.m.wpt.location");
      if (loc) {
        const capitalizedLoc = loc.replace(/\b\w/g, (c) => c.toUpperCase());
        params.set("filter.v.m.wpt.location", capitalizedLoc);
      }
    }
    const url = `${window.origin}${window.location.pathname.replace(
      /\/$/,
      ""
    )}?${params.toString()}`;

    if (document.body.classList.contains("collection") == true) {
      fetch(url)
        .then((response) => response.text())
        .then((html) => {
          const tempDiv = document.createElement("div");
          tempDiv.innerHTML = html;
          const selectors = {
            productGrid: "#product-grid",
            facetFiltersForm: "#FacetFiltersForm",
          };
          Object.entries(selectors).forEach(([key, selector]) => {
            const newContent = tempDiv.querySelector(selector);
            const currentContent = document.querySelector(selector);
            if (newContent && currentContent) {
              // If the key is productGrid, filter items based on date range AND course type
              if (key === "productGrid") {
                const fromDateValue =
                  this.selectors.fromDate.element.value || "";
                const toDateValue = this.selectors.toDate.element.value || "";
                const courseTypeValue =
                  this.selectors.courseType.element.value?.toLowerCase() || "";

                if (
                  fromDateValue.length > 0 ||
                  toDateValue.length > 0 ||
                  courseTypeValue != "null"
                ) {
                  const fromDate = fromDateValue
                    ? new Date(fromDateValue)
                    : null;
                  const toDate = toDateValue ? new Date(toDateValue) : null;

                  const gridItems = newContent.querySelectorAll(".grid__item");
                  gridItems.forEach((item) => {
                    let matches = true;

                    // Date filter
                    if (fromDate || toDate) {
                      const datesAttr = item.getAttribute("data-dates");
                      matches = false;
                      if (datesAttr) {
                        try {
                          let dates;
                          try {
                            dates = JSON.parse(datesAttr);
                          } catch (e) {
                            dates = datesAttr
                              .replace(/^\s*\[|\]\s*$/g, "")
                              .split(",")
                              .map((s) => s.trim().replace(/^"|"$/g, ""));
                          }
                          matches = dates.some((dateStr) => {
                            const date = new Date(dateStr);
                            return (
                              (!fromDate || date >= fromDate) &&
                              (!toDate || date <= toDate)
                            );
                          });
                        } catch (e) {
                          console.warn("Invalid data-dates JSON:", datesAttr);
                        }
                      }
                    }

                    // Course type filter (AND logic)
                    if (matches && courseTypeValue) {
                      const itemCourseType = item
                        .getAttribute("data-course-type")
                        ?.toLowerCase();
                      if (
                        !itemCourseType ||
                        itemCourseType !== courseTypeValue
                      ) {
                        matches = false;
                      }
                    }

                    if (!matches) {
                      item.parentNode && item.parentNode.removeChild(item);
                    }
                  });
                  currentContent.innerHTML = newContent.innerHTML;
                } else {
                  console.log(2);
                  currentContent.innerHTML = newContent.innerHTML;
                }
              } else {
                console.log(3);
                currentContent.innerHTML = newContent.innerHTML;
              }
            }
          });
          window.history.replaceState({}, "", url);
        })
        .finally(() => {
          if (collectionContainer) {
            collectionContainer.classList.remove("loading");
          }
          document.body.classList.add("collection-filtered");
          if (window.Trustpilot) {
            document
              .querySelectorAll(".trustpilot-widget")
              .forEach(function (widget) {
                window.Trustpilot.loadFromElement(widget);
              });
          }
          if (typeof window.compareGridRender === "function") {
            window.compareGridRender();
          }
        })
        .catch((error) => {
          console.error("Error fetching section:", error);
        });
    } else {
      const collectionHandle = this.getAttribute("data-collection-handle");
      const collectionURL = `${window.location.href}/collections/${collectionHandle}`;
      console.log(
        "Redirecting to collection URL:",
        collectionURL + "?" + params.toString()
      );
      window.location.href = collectionURL + "?" + params.toString();
      return;
    }
  }

  onChange() {
    document.body.classList.add("course-search--active");
    const quickCourseSearchElement = this.cloneNode(true);
    const clonedContainer = document.createElement("div"); // Define clonedContainer
    quickCourseSearchElement.appendChild(clonedContainer);
    const niceSelectDiv =
      quickCourseSearchElement.querySelector(".nice-select");
    if (niceSelectDiv) {
      // Remove the existing nice-select div and remove all the styling from the nearest select element
      niceSelectDiv.remove();
      const selectElement = quickCourseSearchElement.querySelector("select");
      if (selectElement) {
        selectElement.classList.remove("nice-select");
        // Remove any inline styles that might have been applied
        selectElement.style.cssText = "";
        selectElement.style.display = "block"; // Ensure the select element is visible
      }
    }

    document.body.appendChild(quickCourseSearchElement);

    if (this.siteDrawer) {
      this.siteDrawer.appendChild(quickCourseSearchElement);
    }
  }

  onClose() {
    document.body.classList.remove("course-search--active");
    const quickCourseSearchElement = this.siteDrawer.querySelector(
      "quick-course-search"
    );
    if (quickCourseSearchElement) {
      this.siteDrawer.removeChild(quickCourseSearchElement);
    }
  }
}

customElements.define("quick-course-search", QuickCourseSearch);
